import { Icon } from "components/Icon/Icon";
import { IconCollection } from "components/Icon/IconCollection";
import { MdiReactIconComponentType } from "mdi-react";
import { PropsWithChildren } from "react";
import "../Autocomplete.scss";
import { Dropdown, ResourceOption, SingleValueInner } from "../ReactSelectComponents";

interface DropdownContainerProps {
    uniqueKey: string;
    name: string;
    selectedValue: ResourceOption | null;
    isOpened: boolean;
    toggleOpened: () => void;
    additionalProps: any;
    iconReplacement?: MdiReactIconComponentType;
    clearValue: (e: React.MouseEvent<HTMLElement>) => void;
    menuInModal?: boolean;
}

export const DropdownContainer = ({
    uniqueKey,
    name,
    selectedValue,
    isOpened,
    toggleOpened,
    additionalProps,
    iconReplacement,
    clearValue,
    menuInModal,
    children,
}: PropsWithChildren<DropdownContainerProps>) => {
    return (
        <Dropdown
            name={name}
            isOpened={isOpened}
            menuInModal={menuInModal}
            onClose={toggleOpened}
            targetClassName={`${
                additionalProps?.renderIconOnly ? "react-select__dropdown-icon" : ""
            }`}
            targetStyle={
                additionalProps?.fieldWidth ? { width: additionalProps?.fieldWidth } : undefined
            }
            target={
                additionalProps?.renderIconOnly && additionalProps?.iconOnlyComponent ? (
                    <div onClick={toggleOpened} data-id={name} id={uniqueKey}>
                        {additionalProps.iconOnlyComponent({
                            hasValue: selectedValue?.label,
                            isDisabled: additionalProps?.disabled,
                        })}
                    </div>
                ) : (
                    <div
                        className={`react-select__target${isOpened ? " is_opened" : ""}`}
                        onClick={toggleOpened}
                        id={uniqueKey}
                        data-testid="react-select__target"
                    >
                        {selectedValue?.label ? (
                            <div className="singleValueContainer">
                                <SingleValueInner
                                    data={selectedValue}
                                    iconReplacement={iconReplacement}
                                />
                            </div>
                        ) : (
                            <span style={{ opacity: 0.5 }}>
                                {additionalProps?.placeholder ?? "Select an option"}
                            </span>
                        )}
                        <div className="react-select__indicators">
                            {selectedValue?.label && additionalProps?.clearable !== false && (
                                <span className="react-select__target-icon" onClick={clearValue}>
                                    <Icon icon={IconCollection.close} />
                                </span>
                            )}
                            <span className="react-select__target-icon react-select__dropdown-indicator">
                                <Icon icon={IconCollection.chevronDown} />
                            </span>
                        </div>
                    </div>
                )
            }
        >
            <div className="react-select__custom-menu">{children}</div>
        </Dropdown>
    );
};
